<article class="row">
  <div class="flex-full-width">

    <div class="col col1" (click)="showDetail(eventResult)">
      <div class="time-code-wrap">
        <span class="time">{{eventResult.eventTime}}</span>
        <span class="code" *ngIf="!viewConfigurations.hideEventCodeInEvent">{{eventResult.eventCode}}</span>
        <!-- <span class="code">{{event.code}}</span> -->
        <i *ngIf="viewConfigurations.hideEventCodeInEvent"
          class="icon-ex-sm s-icon-{{getSportName(eventResult.sportId)}} sportid-{{eventResult.sportId}}"></i>
      </div>
      <div class="event-name">
        <div class="home-away">
          <ng-container *ngIf="eventResult.homeTeam != null || eventResult.awayTeam !==null; else outright;">
            <span class="home">{{eventResult.homeTeam}}</span>
            <span class="away">{{eventResult.awayTeam}}</span>
          </ng-container>
          <ng-template #outright>
            <span>{{eventResult.eventName}}</span>
          </ng-template>

        </div>
      </div>
    </div>
    <div class="col col2">
      <ng-container *ngFor="let scoreGroup of scoreGroups; let i = index">
        <div class="bet-type-col">
          <ng-container *ngIf="eventResult.results[scoreGroup.id]; let eventResults">
            <ng-container *ngFor="let scorePeriod of eventResults.scorePeriods; let j = index;">

              <div class="score">
                <ng-container *ngIf="eventResults.hasHomeAway; else singleScore">
                  <span>{{scorePeriod.homeAwayValue[enumsHomeAway.HOME]}}</span>
                  <span>{{scorePeriod.homeAwayValue[enumsHomeAway.AWAY]}}</span>
                </ng-container>
                <ng-template #singleScore>
                  <span>{{scorePeriod.homeAwayValue[enumsHomeAway.NONE]}}</span>
                </ng-template>
              </div>

            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="col col-bets">
    <div class="expand-event" (click)="showDetail(eventResult)">+</div>
  </div>


</article>
